export const isVue = (): boolean => {
  return Boolean(window?.APP);
};
